import { Box } from '@material-ui/core'
import { ContentBlock } from '../components'
import InsuranceCards from '../MemberCard/InsuranceCards'

interface InsuranceValidatingCardUploadProps {
  order: APIResponse.DME.Order
}

export default function InsuranceValidatingCardUpload({
  order,
}: InsuranceValidatingCardUploadProps) {
  return (
    <ContentBlock title="Insurance next steps" variant="warn">
      <Box mb={2}>
        We need some help from you to verify your insurance. Please upload a
        front and back image of your insurance card below.
      </Box>
      Once verified, we will update the status to "Valid." If there are concerns
      with your insurance, we will email directly.
      <InsuranceCards order={order} />
    </ContentBlock>
  )
}
